module.exports = __webpack_public_path__ + "img/111.7ee0c040.jpg";